<template>
  <div class="sextants h-100">
    <Table
      :fields="fields"
      :league="this.$parent.league"
      category="sextants"
      :smallScreen="smallScreen"
      :getHref="this.getHref"
    ></Table>
  </div>
</template>

<script>
// @ is an alias to /src
import Table from "../components/Sextants.vue";
import isMobile from "../mixins/mobileCheck";
export default {
  name: "Sextants",
  components: { Table },
  mixins: [isMobile],
  props: ["smallScreen"],
  data() {
    return {
      privateLeague: false,
      fields: [
        {
          key: "icon",
          sortable: false,
          thStyle: "width: 3em;",
        },
        {
          key: "name",
          sortable: false,
        },
        {
          key: "uses",
          sortable: true,
        },
        {
          key: "mean",
          sortable: true,
          tdClass: "text-right",
          thClass: "text-right",
        },
      ],
    };
  },
  mounted() {
    var subdomain = window.location.host.split(".")[1]
      ? window.location.host.split(".")[0]
      : false;
    if (subdomain === "private") {
      this.privateLeague = true;
    } else {
      this.privateLeague = false;
    }
  },
  methods: {
    getHref(item) {
      if (item != undefined) {
        let sacrifice = item.sacrifice; // orb of regal
        //let output = "abc" // unique
        // let challenge = "abc" // Survive, Protect the Altar, 	Defeat waves of enemies, Stand in the Stone Circles
        let reward = "abc"; // DoubleCurrency

        if (item.reward == "Doubles sacrificed Currency") {
          return `https://www.pathofexile.com/trade/search/${this.$parent.league}?q={"query":{"status":{"option":"online"},"type":"Inscribed Ultimatum","stats":[{"type":"and","filters":[],"disabled":false}],"filters":{"ultimatum_filters":{"filters":{"ultimatum_input":{"option":"${sacrifice}"},"ultimatum_reward":{"option":"DoubleCurrency"}},"disabled":false}}},"sort":{"price":"asc"}}`;
        }
        if (item.reward == "Doubles sacrificed Divination Cards") {
          return `https://www.pathofexile.com/trade/search/${this.$parent.league}?q={"query":{"status":{"option":"online"},"type":"Inscribed Ultimatum","stats":[{"type":"and","filters":[],"disabled":false}],"filters":{"ultimatum_filters":{"filters":{"ultimatum_input":{"option":"${sacrifice}"},"ultimatum_reward":{"option":"DoubleDivCards"}},"disabled":false}}},"sort":{"price":"asc"}}`;
        }
        return `https://www.pathofexile.com/trade/search/${this.$parent.league}?q={"query":{"status":{"option":"online"},"type":"Inscribed Ultimatum","stats":[{"type":"and","filters":[],"disabled":false}],"filters":{"ultimatum_filters":{"filters":{"ultimatum_input":{"option":"${sacrifice}"},"ultimatum_output":{"option":"${reward}"},"ultimatum_reward":{"option":"ExchangeUnique"}},"disabled":false}}},"sort":{"price":"asc"}}`;
      }
    },
  },
};
</script>

<style>
p,
h4 {
  color: white;
}
</style>
